module.exports = __webpack_public_path__ + "img/thunder.7142c78b.svg";